import React from 'react';
import { motion } from 'framer-motion';

const JoinUsCTA = () => {
	return (
		<section className="relative overflow-hidden py-12">
			<div className="absolute inset-0 bg-gradient-to-b from-white via-lime-200 to-lime-500" />
			<div className="relative max-w-3xl mx-auto px-6 sm:px-8 md:px-12 py-10 sm:py-12 text-center">
				<motion.h3
					initial={{ opacity: 0, y: 10 }}
					whileInView={{ opacity: 1, y: 0 }}
					viewport={{ once: true, amount: 0.5 }}
					transition={{ duration: 0.5 }}
					className="font-source italic text-3xl md:text-4xl text-[#113861] font-bold"
				>
					Join Us
			
				</motion.h3>
				<motion.p
					initial={{ opacity: 0, y: 10 }}
					whileInView={{ opacity: 1, y: 0 }}
					viewport={{ once: true, amount: 0.5 }}
					transition={{ duration: 0.6, delay: 0.1 }}
					className="mt-3 text-[18px] leading-6 text-[#113861] font-sans font-regular"
				>
					At Analytical Prism, your work is not merely a job; it’s a mission to transform lives through science. If you are
					looking for an environment where intellectual curiosity is valued, creativity is encouraged, and innovation is a way
					of life, we would be delighted to hear from you.
				</motion.p>
			</div>
		</section>
	);
};

export default JoinUsCTA;


